import axiosInstance from "../Interceptor";

export const getTopCustomersApi = (payload) => {
  return axiosInstance
    .get(`orders/api/v1/orders/regional_admin/users/${payload}/`)

    .then(function (response) {
      return response;
    })
    .catch((error) => {
    
      return error;
    });
};
